import type { Game, GameMeta } from './types';
import { InvadersGame } from './invaders/InvadersGame';
import { SideRaidGame } from './rtype/SideRaidGame';
import { DotRunGame } from './pac/DotRunGame';
import { BeatChaseGame } from './trex/BeatChaseGame';
import { WaveDodgeGame } from './wave/WaveDodgeGame';
import { MomohaCannonGame } from './cannon/MomohaCannonGame';
import { BeatPongGame } from './pong/BeatPongGame';
import { VelvetRopeRiotGame } from './velvet/VelvetRopeRiotGame';
import { RhythmDuelGame } from './rhythm-duel/RhythmDuelGame';
import { ChronoDefenderGame } from './chrono-defender/ChronoDefenderGame';
import { CyberDefenderGame } from './cyber-defender/CyberDefenderGame';
import { AstroBubbleGame } from './astro-bubble/AstroBubbleGame';
import { AstroGame } from './astro/AstroGame';
import { GridSlicerGame } from './grid-slicer/GridSlicerGame';
import { SonicSiloGame } from './sonic-silo/SonicSiloGame';

export const GAME_CATALOG: GameMeta[] = [
  {
    id: 'grid-slicer',
    title: 'NEON GRID SLICER',
    blurb: 'Qix territory carver. Slice neon sectors, trap open-grid drones, trigger Sonic Pulses & powerups!',
    tag: 'ARCADE',
    status: 'playable',
  },
  {
    id: 'sonic-silo',
    title: 'SONIC SILO DEFENSE',
    blurb: '3-Silo Missile Command + Shielded Cities. Trigger EMP Stasis blasts, Gravity Auras & shockwave cascades!',
    tag: 'ARCADE',
    status: 'playable',
  },
  {
    id: 'cyber-defender',
    title: 'ASTRO-BUBBLE DEFENDER',
    blurb: 'Asteroids + Space Invaders + Bubble Bobble fusion. Encase space hazards & pop chain combos!',
    tag: 'ARCADE',
    status: 'playable',
  },
  {
    id: 'astro-bubble',
    title: 'ASTRO BUBBLE GUARDIAN',
    blurb: 'Classic arcade fusion. Trap invaders in energy bubbles & trigger chain-pop combos!',
    tag: 'ARCADE',
    status: 'playable',
  },
  {
    id: 'astro',
    title: 'NEON TACTICS: GRAVITY SURGE',
    blurb: 'Tactical vector shooter. Trap invaders in stasis, pulse gravity fields & deflect plasma!',
    tag: 'TACTICAL',
    status: 'playable',
  },
  {
    id: 'chrono-defender',
    title: 'CHRONO DEFENDER',
    blurb: 'Vector wave defense. Trap invaders in Chrono-Bubbles and pop combo chain cascades.',
    tag: 'ARCADE',
    status: 'playable',
  },
  {
    id: 'pong',
    title: 'BEAT PONG (ONLINE)',
    blurb: '1v1 Online Multiplayer. The arena pulses to the beat.',
    tag: 'MULTIPLAYER',
    status: 'playable',
  },
  {
    id: 'rhythm-duel',
    title: 'BEAT BRAWL (ONLINE)',
    blurb: '1-button rhythm duel. Alternate attack/defend sections on a shared beat timeline.',
    tag: 'MULTIPLAYER',
    status: 'playable',
  },
  {
    id: 'invaders',
    title: 'SPACE DROP',
    blurb: 'Formation shooters. Beat marches the swarm. Music is difficulty.',
    tag: 'ARCADE',
    status: 'playable',
  },
  {
    id: 'rtype',
    title: 'SIDE RAID',
    blurb: 'Orbit the core, shoot inward. Multi / rapid / shield powerups.',
    tag: 'ARCADE',
    status: 'playable',
  },
  {
    id: 'pac',
    title: 'DOT RUN',
    blurb: 'Maze chase. Drag cam. FIRE fright bomb.',
    tag: 'ARCADE',
    status: 'playable',
  },
  {
    id: 'trex',
    title: 'BEAT CHASE',
    blurb: '3-lane beat runner. Notes, shield, slow-mo. Drag cam.',
    tag: 'RUNNER',
    status: 'playable',
  },
  {
    id: 'wave',
    title: 'WAVE SURF',
    blurb: 'Smooth ocean waves. Lean, hop, drag cam.',
    tag: 'SURF',
    status: 'playable',
  },
  {
    id: 'velvet',
    title: 'VELVET ROPE RIOT',
    blurb: 'On-rails neon shooter. Pointer aim or D-pad crosshair. Beat spikes the gatekeepers.',
    tag: 'SHOOTER',
    status: 'playable',
  },
  {
    id: 'cannon',
    title: 'FREEMUSIERS CANNONADE',
    blurb: 'THE GREAT FREEMUSIERS CANNONADE — lock angle & power, yeet the TGN ninja. Beat hang-time!',
    tag: 'CARNIVAL',
    status: 'playable',
  },
];

export function createGame(id: string): Game | null {
  switch (id) {
    case 'pong':
      return new BeatPongGame();
    case 'rhythm-duel':
      return new RhythmDuelGame();
    case 'invaders':
      return new InvadersGame();
    case 'rtype':
      return new SideRaidGame();
    case 'pac':
      return new DotRunGame();
    case 'trex':
      return new BeatChaseGame();
    case 'wave':
      return new WaveDodgeGame();
    case 'velvet':
      return new VelvetRopeRiotGame();
    case 'cannon':
      return new MomohaCannonGame();
    case 'chrono-defender':
      return new ChronoDefenderGame();
    case 'cyber-defender':
      return new CyberDefenderGame();
    case 'astro-bubble':
      return new AstroBubbleGame();
    case 'astro':
      return new AstroGame();
    case 'grid-slicer':
      return new GridSlicerGame();
    case 'sonic-silo':
      return new SonicSiloGame();
    default:
      return null;
  }
}
